// ネイティブのWeb Crypto APIを使用 @SEE: https://developer.mozilla.org/ja/docs/Web/API/Web_Crypto_API
export const generateHashedString = async (text: string): Promise<string> => {
  const encoder = new TextEncoder();
  // (utf-8 の)Uint8Array にエンコードする
  const data = encoder.encode(text);
  const hash = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hash));
  // バイト列を16進文字列に変換する
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};
